import {useEffect, useRef, useState} from "react";
import L from 'leaflet/dist/leaflet';
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import 'leaflet/dist/leaflet.css';
import HelperService from "../services/helper-service";

export default function MapCell( {lat=null, lon=null, gps=true, controls=true, ...props} ){

    const [initialPosition, setInitialPosition] = useState(null);
    const mapRef = useRef(null);

    const DefaultIcon = L.icon({ iconUrl: icon, shadowUrl: iconShadow });
    const containerId = 'map-picker';

    //init position as its needed for map init
    useEffect(() => {
        getInitialPosition().then((res)=>{
            setInitialPosition(res);
        })
    }, [])

    //init map
    useEffect(() => {
        if (!mapRef?.current && initialPosition?.lat && initialPosition?.lon){

            const position = initialPosition;

            const container = L.DomUtil.get(containerId);
            if (container != null) {
                container._leaflet_id = null;
            }
            mapRef.current = L.map(containerId, {zoomControl: controls}).setView([position.lat,position.lon],17);
            L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png",
                {
                    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    maxZoom: 19,
                }
            ).addTo(mapRef.current);

            // init locate button
            if (gps){
                const LocationControl = L.Control.extend({
                    options: {
                        position: 'bottomleft'
                    },
                    onAdd: function () {
                        const controlsContainer = L.DomUtil.create('div', 'leaflet-bar');
                        controlsContainer.innerHTML = '<a class="clickable" id="get-location"><span class="mdi mdi-crosshairs-gps"></span></a>';
                        controlsContainer.onclick = function () {
                            HelperService.log(['locateMe']);
                            getCurrentLocation().then((pos)=>{
                                if (pos?.lat && pos?.lon){
                                    mapRef.current.setView([pos.lat,pos.lon], mapRef.current.getZoom());
                                }
                            });
                        }
                        return controlsContainer;
                    }
                });
                mapRef.current.addControl(new LocationControl());
            }

            //init marker
            L.Marker.prototype.options.icon = DefaultIcon;
            const newMarker = L.marker([position.lat,position.lon]).addTo(mapRef.current);

            HelperService.respondToVisibility(container, ()=>{mapRef.current.invalidateSize();})
        }
    }, [initialPosition]);

    async function getCurrentLocation(){
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                position => {
                    if (position?.coords?.latitude && position?.coords?.longitude) {
                        resolve({
                            lat: position.coords.latitude,
                            lon: position.coords.longitude,
                        });
                    } else {
                        resolve(null);
                    }
                },
                err => {
                    HelperService.log(err);
                    resolve(null); // Resolve with null when there is an error
                }
            );
        });
    }

    async function getInitialPosition(){
        let newLocation = null
        if (gps){
            // this only on button click to prevent warning
            // newLocation = await getCurrentLocation();
        }
        return {
            lat: newLocation?.lat || lat || 40.00058,
            lon: newLocation?.lon || lon || -75.296791,
        };
    }

    return (
        <>
            <div id={containerId} style={{height: '100%', zIndex:0}}></div>
        </>
    );
}
